import { render, staticRenderFns } from "./TextToolbar.vue?vue&type=template&id=2e78e787&scoped=true"
import script from "./TextToolbar.vue?vue&type=script&lang=js"
export * from "./TextToolbar.vue?vue&type=script&lang=js"
import style0 from "./TextToolbar.vue?vue&type=style&index=0&id=2e78e787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e78e787",
  null
  
)

export default component.exports